import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
import cookies from 'js-cookie';
import crypto from 'crypto';
import servers from '@/configs/servers';

// 当前环境的server
const server = servers[location.hostname] || servers['openapi.huoyunren.com'];

// 把对象转换为FormData
const toFormData = (originData) => {
    if (!originData) return null;

    const newFormData = new FormData();
    function transformToFormData(formData, data, parentKey) {
        if (
            data &&
            typeof data === 'object' &&
            !(data instanceof Date) &&
            !(data instanceof window.File)
        ) {
            Object.keys(data).forEach((key) => {
                let tempKey;
                if (Array.isArray(data)) {
                    tempKey = parentKey ? `${parentKey}[${key}]` : key;
                } else {
                    tempKey = parentKey ? `${parentKey}.${key}` : key;
                }
                transformToFormData(
                    formData,
                    data[key],
                    tempKey,
                );
            });
        } else {
            const value = data === null ? '' : data;
            formData.append(parentKey, value);
        }
    }
    transformToFormData(newFormData, originData);
    return newFormData;
};
const sortData = (data) => {
    if (typeof data !== 'object') return;
    const keysArr = Object.keys(data).sort();
    const newData = {};
    keysArr.forEach((item) => {
        console.log(item);
        newData[`${item}`] = data[`${item}`];
        if (typeof newData[`${item}`] === 'object' && Object.keys(newData[`${item}`]).length > 0) {
            newData[`${item}`] = sortData(newData[`${item}`]);
        }
    });
    return newData;
};
// 添加请求拦截器
axios.interceptors.request.use((config) => {
    // 在发送请求之前做些什么
    const { contentType = 'form', url, data, headers, ...axiosConfig } = config;
    const baseURL = server.url;
    axiosConfig.url = url.startsWith('/') ? `${baseURL}${url}` : `${baseURL}/${url}`;
    axiosConfig.headers = { ...(headers || {}),
        'x-g7-gt': cookies.get('GT') || '',
        'X-G7-OpenApi-Web-Token': cookies.get('GT') ? '' : cookies.get('Token'),
    };
    if (contentType === 'form') {
        axiosConfig.data = qs.stringify(data);
    } else if (contentType === 'json') {
        axiosConfig.data = data;
    } else if (contentType === 'formData') {
        axiosConfig.data = toFormData(data);
    } else if (contentType === 'json_sort_az') {
        axiosConfig.data = sortData(data);
    }

    return axiosConfig;
}, (error) => {
    console.log(`request::error->${error}  data->${config}`);
    Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(({ data = {}, headers }) => {
    // 对响应数据做点什么
    const code = data.code * 1;
    const subCode = data.sub_code * 1;

    if (code !== 0) {
        Vue.$_message.error(data.msg);
        return Promise.reject(data.msg);
    } else if (code == 100707 || code == 2001102023) {
        if (location.hostname === 'localhost') {
            return Promise.reject('正在重新载入');
        }
        cookies.remove('GT');
        window.location.reload();
        return Promise.reject('正在重新载入');
    } else if (subCode !== 0) {
        if (subCode === 1004001002) {
            if (!window._loginMsgCount) {
                Vue.$_message.error('登录超时，请重新登录');
                window._loginMsgCount = 1;
            }
            setTimeout(() => {
                Vue.$pub.toIndex();
                window._loginMsgCount = 0;
            }, 300);
        } else {
            Vue.$_message.error(data.sub_msg);
        }
        return Promise.reject(data.sub_msg);
    }
    if(headers['token']) {
        cookies.set('Token', headers['token'])
    }
    return data.data === undefined ? data : data.data;
}, (error) => {
    // 对响应错误做点什么
    // let message = error.message;
    let message = '系统波动，请稍后重试';
    let status = '';

    if (error.response) {
        status = error.response.status;

        if (error.response.data && error.response.data.message) {
            message = error.response.data.message;
            if (message.length > 20) {
                message = '系统波动，请稍后重试';
            }
        }
    }

    // console.log(`response::error->${error}  data->${error.response.data}`);
    if (status === 500 && error.response && error.response.data) {
        const code = error.response.data.code * 1;
        if (code == 100707 || code == 100700 || code == 2001102023) {
            if (location.hostname === 'localhost') {
                return Promise.reject('正在重新载入');
            }
            cookies.remove('GT');
            window.location.reload(true);
            return Promise.reject('正在重新载入');
        }
    }

    // 统一提示接口业务错误
    if (message) Vue.$_message.error(message);
    if (status === 401) Vue.$pub.toIndex();


    return Promise.reject(error);
});

function makeApiSign(reqType, path) {
    let serverConfig;
    let path_;
    if (path.indexOf('@') > -1) {
        serverConfig = server.sandbox;
        path_ = path.split('@')[1];
    } else {
        serverConfig = server;
        path_ = path;
    }
    const { skey: secretKey, id: accessid } = serverConfig;
    const g7timestamp = Date.now();
    const stringToSign = `${reqType.toUpperCase()}\n${g7timestamp}\n/${path_}`;
    const sign = crypto.createHmac('sha1', secretKey).update(stringToSign).digest().toString('base64');
    let u = cookies.get('X-G7-Userinfo') || null;
    if (u) {
        u = JSON.parse(u);
    }
    return {
        accessid,
        sign,
        g7timestamp,
        source: u ? u.source : ''
    };
}

/**
 * 封装post、get方法，并对axios的config配置拓展了一个contentType参数
 * url    ''  String类型参数  请求的api地址
 * data   {}  Object类型参数  请求的数据
 * config {}  Object类型参数  axios的config配置,并拓展了一个contentType参数,如{ contentType: 'form'|json'|'formData' }，默认'form'
 */
function post(url = '', data = {}, config = {}) {
    url = `${url}?${qs.stringify(makeApiSign('post', url))}`;

    return axios.post(url, data, config);
}
function dele(url = '', data = {}, config = {}) {
    url = `${url}?${qs.stringify(makeApiSign('delete', url))}`;

    return axios.delete(url, data, config);
}

function get(url = '', data = {}, config = {}) {
    url = `${url}?${qs.stringify({ ...data, ...makeApiSign('get', url) })}`;

    return axios.get(url, config);
}

function exportFile(url = '', data = {}) {
    const exportUrl = `${server.url}${url}?${qs.stringify({ ...data, ...makeApiSign('get', url) })}`;

    location.href = exportUrl;
}

export default {
    install() {
        Vue.$http = Vue.prototype.$http = {
            post,
            get,
            dele,
            exportFile,
            toFormData
        };
    },
};

export {
    post,
    get,
    dele,
    exportFile,
    toFormData
};



// WEBPACK FOOTER //
// ./src/assets/js/http.js